var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPawicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76098 7.13084C5.76098 5.53393 4.47098 4.23901 2.88021 4.23901C1.28943 4.23901 0 5.53393 0 7.13084C0 8.72889 1.28915 10.0232 2.88021 10.0232C4.47126 10.0232 5.76098 8.72889 5.76098 7.13084Z",
    fill: "#F0EAE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.248 4.80396C15.6575 4.80396 14.3678 6.09887 14.3678 7.69578C14.3678 9.29383 15.6575 10.5876 17.248 10.5876C18.8388 10.5876 20.1285 9.29383 20.1285 7.69578C20.1285 6.09887 18.8391 4.80396 17.248 4.80396Z",
    fill: "#F0EAE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.632 10.9148C14.4317 10.667 14.1483 10.3801 13.8228 10.0793C12.9543 8.94917 11.5958 8.21802 10.0644 8.21802C8.70141 8.21802 7.47617 8.79747 6.6102 9.72082C6.11829 10.1506 5.6809 10.57 5.40257 10.9151L5.21625 11.1435C4.34716 12.2074 3.26535 13.5312 3.2733 15.7774C3.28097 17.8633 4.97285 19.5615 7.04446 19.5615C8.22767 19.5615 9.31205 19.0122 10.0173 18.0903C10.7219 19.0122 11.8066 19.5615 12.9909 19.5615C15.0617 19.5615 16.7533 17.8636 16.7612 15.7774C16.7692 13.5312 15.6871 12.2074 14.8183 11.1435L14.632 10.9148Z",
    fill: "#F0EAE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2641 6.37337C12.0169 6.37337 13.4379 4.94664 13.4379 3.18668C13.4379 1.42673 12.0169 0 10.2641 0C8.51117 0 7.09018 1.42673 7.09018 3.18668C7.09018 4.94664 8.51117 6.37337 10.2641 6.37337Z",
    fill: "#F0EAE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawicon);
export default __webpack_public_path__ + "static/media/pawicon.9a33f085ceac5f16faa0c4caa11cb90a.svg";
export { ForwardRef as ReactComponent };